<template>
  <a-modal
    centered
    :visible="open"
    @cancel="closeModal"
    :footer="null"
    width="900px"
    wrapClassName="request-plan-change"
  >
    <div class="principal-background" />
    <div class="modal-content">
      <div class="modal-left">
        <img :src="showAlert ? ovniAlert : ovni" alt="Upgrade" />
        <h2>{{ title }}</h2>
        <slot name="body">
          <p>
            <slot name="description">
              Tu plan Digital no incluye el canal de Voz. Solicita un upgrade y potencia tu ambiente de trabajo.
              ¡Que tu viaje no se detenga!
            </slot>
          </p>
          <p class="subtitle">Accederás a lo siguiente</p>
          <ul class="list-access">
            <li>
              <img :src="checkCircleIcon" alt="Icono" class="icon" />
              Acceso a todos los canales.
            </li>
            <li>
              <img :src="checkCircleIcon" alt="Icono" class="icon" />
              Formularios ilimitados.
            </li>
            <li>
              <img :src="checkCircleIcon" alt="Icono" class="icon" />
              Funcionalidades especiales.
            </li>
            y muchos beneficios más.
            <p v-if="isClientBeexcc" style="margin-top: 12px">Cuenta con nosotros para elevar tu experiencia. Estamos listos para asistirte. ✨</p>
          </ul>
        </slot>
        <div v-if="isClientBeexcc" style="margin-top: 20px">
          <a-button type="primary" @click="contactAdvisor">
            Contactar asesor
            <WhatsAppOutlined />
          </a-button>
          <a-button v-if="planRequest && !showAlert && !advisorOnly" style="margin-left: 8px" @click="visibleModalRequest = true">
            {{ requestButtonLabel || `Upgrade ${PlanTypeText[planRequest as PlanType]}` }}
          </a-button>
          <a-button v-else-if="!showAlert && !advisorOnly" style="margin-left: 8px" @click="viewPlans">
            Ver planes
          </a-button>
          <a-button v-else-if="!advisorOnly" style="margin-left: 8px" @click="visibleModalRequest = true">
            Personalizar plan
          </a-button>
        </div>
        <a-alert v-if="!isClientBeexcc" type="info" show-icon style="margin-top: 20px">
          <template #message>
            Recuerda que debes contactar a tu asesor de ventas para solicitar un upgrade o personalizar tu plan.
          </template>
        </a-alert>
        <a-alert v-else-if="showAlert" type="info" show-icon style="margin-top: 20px">
          <template #message>
            Recuerda que también puedes mejorar tu ambiente de trabajo con un upgrade. <br/>
            <a-button class="link_underline" type="link" @click="viewPlans">
              Conoce nuestros planes.
            </a-button>
          </template>
        </a-alert>
      </div>
      <div class="modal-right">
        <img :src="rocketPlan" alt="Upgrade" />
      </div>
    </div>
  </a-modal>
  <request-change-plan-modal
    v-model:open="visibleModalRequest"
    @close="closeModal"
    :idPlanChange="planRequest ?? (idPlan + 1)"
  />
</template>

<script setup lang="ts">
import { defineProps, defineEmits, computed, ref } from "vue";
import rocketPlan from "@/app/common/assets/rocket-plan.jpg?url";
import ovni from "@/app/common/assets/ovni.svg?url";
import ovniAlert from "@/app/common/assets/ovni-alert.svg?url";
import checkCircleIcon from "@/app/common/assets/check-circle-icon.svg?url";
import { WhatsAppOutlined } from "@ant-design/icons-vue";
import RequestChangePlanModal from "@/app/settings/components/modals/RequestChangePlanModal.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { PlanType, PlanTypeText } from "../../types";

const props = withDefaults(
  defineProps<{
    open: boolean;
    title: string;
    showAlert?: boolean;
    planRequest?: number | undefined;
    requestButtonLabel?: string;
    /**
     * Hides the secondary plan-request action so only the advisor contact
     * (WhatsApp) button is offered. Used when talking to a sales advisor is
     * the only viable path forward for this plan.
     */
    advisorOnly?: boolean;
  }>(),
  {
    open: false,
    title: '',
    showAlert: false,
    planRequest: undefined,
    requestButtonLabel: '',
    advisorOnly: false,
  }
);
const emit = defineEmits(["update:open"]);
const router = useRouter();

const visibleModalRequest = ref(false);
const store = useStore();
const user = computed(() => store.getters["getDataUser"]);
const idPlan = computed(() => user.value?.change_custom_plan?.plan);
const isClientBeexcc = computed(() => user.value?.is_beexcc);

// WhatsApp comercial de Beex. La variable de entorno permite cambiarlo por ambiente
// sin recompilar; el literal es el fallback para los builds que no la definen, que de
// otro modo abrirían una pestaña a "undefined".
const SALES_WHATSAPP_URL =
  import.meta.env.VITE_WHATSAPP_BEEX || "https://wa.me/51962285844";

const closeModal = () => {
  emit("update:open", false);
};

const contactAdvisor = () => {
  window.open(SALES_WHATSAPP_URL, "_blank", "noopener,noreferrer");
};

const viewPlans = () => {
  window.open("/billing?key=plan", "_blank", "noopener noreferrer");
  // router.push("/billing?key=plan");
};
</script>

<style scoped lang="sass">
.principal
  &-background
    width: 100%
    height: 16px
    border-radius: 6px 6px 0 0
    display: flex
    justify-content: center
    align-items: end
    background: linear-gradient(180deg, #762ECF 0%, #B51DCF 100%)
  &_image
    flex: 1
    width: 100%
    // height: 596px
    overflow: hidden
    position: relative
    img
      width: 100%
      height: auto
      object-fit: cover
      object-position: center
      position: absolute
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)

.subtitle
  font-weight: 500
  margin-bottom: 0.5em

.modal-content
  display: flex
  align-items: center
  // justify-content: space-between

.modal-left
  // flex: 1
  min-width: 424px
  padding: 30px 40px

.modal-right
  // flex: 1
  img
    width: 476px

.list-access
  list-style: none
  padding-left: 0

.link_underline
  padding: 0
  height: auto !important
:global(.link_underline span)
  text-decoration: underline !important

:global(.request-plan-change .ant-modal-close)
  margin-top: 10px
  margin-left: 5px
  inset-inline-end: 11px
  color: #fff !important

// .modal-right img
//   width: 100%
//   max-width: 250px

:global(.request-plan-change .ant-modal-content)
  padding: 0
  overflow: hidden

:global(.request-plan-change .ant-modal-close)
  color: $gray-9

:global(.request-plan-change .ant-modal-close:hover)
  color: white
</style>
  